// since there's no dynamic data here, we can prerender
// it so that it gets served as a static asset in production
export const ssr = true
export const prerender = true

import { getServerLocale } from '~/utils/getServerLocale'
import type { LayoutLoad } from '../../../../$types'
import { ContentManagerSystem } from '../../../../../config/content-manager-system'

const requestManagerSystem = ContentManagerSystem(`
query WorkQuery($locale: SiteLocale = pt_BR, $slug: String = "consul-te") {
	workPage(locale: $locale) {
	  subtitle
	}
	work(filter: {slug: {eq: $slug }}, locale: $locale) {
	  metadata {
	  	title
	  	description
	  }

	  id
	  title
	  description
	  descriptionComplete

	  gallery {
      	url
      	alt
      }
	  
	  image {
		url
		alt
	  }
	  customer {
		name
		image {
		  url
		  alt
		}
	  }
	  slug
	}
  }
`)

export const load: LayoutLoad = async (request) => {
  const params = request.params

  const locale = getServerLocale(params.locale as string)

  const response = await requestManagerSystem({
    locale: locale.contentManagerSystem,
    slug: params.slug,
  })

  return response
}

const requestWorkSlugManagerSystem = ContentManagerSystem(`
query WorkSlugQuery {
	allWorks {
	  slug
	}
  }
`)

export async function entries() {
  const localeList = ['en', 'pt-br']

  const response = await requestWorkSlugManagerSystem()

  let result: any[] = []

  console.log(response)

  localeList.forEach((locale) => {
    const localeWords = response.allWorks.map((work: { slug: string }) => ({ locale, ...work }))
    result = result.concat(localeWords)
  })

  return result
}
